/* ==========================================================================
   SHŌ ITO — sk-core.js（全ページ共通の動き）
   1. 流入元（UTM）の記録        … snippets/si-signup.liquid に移した（localStorage キー si_attr_v1 は同じ）
   2. 通知バー                    … ×で閉じる（告知 ID ごとに記憶）
   3. ヘッダー                    … 下へスクロールで退き、上へ戻すと白背景で再出現（§03-2）
   4. パネル（メニュー・検索）     … 背景の暗転とぼかし、Esc・×・背景クリックで閉じる
   5. 検索                        … 入力前の候補＋Shopify 予測検索
   6. 登録フォーム（Klaviyo）      … 共通部品 siKlaviyoSubscribe で送る（Waitlist / Newsletter の独立した選択）
   7. 登録ポップアップ P1 → ドック → 完了 P5（cookie 名も今のサイトと同じ）
   8. 動画（画面内で再生・画面外で停止・停止ボタン・音）／カルーセル（位置表示）／入場
   9. Cookie 設定の開き直し・コントラスト切替・カート件数
   ========================================================================== */
(function () {
  'use strict';
  var SK = window.SK = window.SK || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  SK.reduceMotion = reduceMotion;

  /* ---------- 小道具 ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function getCookie(n) { var m = document.cookie.match('(?:^|; )' + n.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : null; }
  function setCookie(n, v, days) { var d = new Date(); d.setTime(d.getTime() + days * 864e5); document.cookie = n + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax'; }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  SK.$ = $; SK.$$ = $$; SK.getCookie = getCookie; SK.setCookie = setCookie;

  /* ---------- 1. 流入元（UTM）---------- */
  // 2026-10-05: 流入元の記録（window.siSignupAttribution）は snippets/si-signup.liquid に移した（layout の <head> で読み込む＝本番テーマと同じ部品）。
  // ⬜旧＝ここに同じ処理を持っていた（控え＝_backup/2026-10-05_before-klaviyo-client-subscriptions/sk-core.js）。

  /* ---------- 2. 通知バー ---------- */
  function initAnnouncement() {
    var bar = $('[data-sk-announce]'); if (!bar) return;
    var id = bar.getAttribute('data-sk-announce-id');
    if (store('sk_announce_closed') === id) { bar.hidden = true; return; }
    var btn = $('[data-sk-announce-close]', bar);
    if (btn) btn.addEventListener('click', function () { bar.hidden = true; store('sk_announce_closed', id); });
  }

  /* ---------- 3. ヘッダー（Dior と同じ: 上端に固定・下へスクロールでフェードして消え、上へ戻すと現れる） ---------- */
  function initHeader() {
    var header = $('[data-sk-header]'); if (!header) return;
    var lastY = window.scrollY, ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY;
      // 上端に貼り付く位置＝通知バーの下端（貼り付いた要素の offsetTop は貼り付き後の位置を返すので使わない）
      var bar = $('[data-sk-announce]');
      var stuckAt = (bar && !bar.hidden) ? bar.offsetTop + bar.offsetHeight : 0;
      header.classList.toggle('is-scrolled', y > stuckAt + 1);
      if (y <= stuckAt + header.offsetHeight) header.classList.remove('is-hidden');
      else if (y > lastY + 2) header.classList.add('is-hidden');
      else if (y < lastY - 2) header.classList.remove('is-hidden');
      lastY = y;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- 4. パネル・モーダル共通 ---------- */
  var openStack = [];
  SK.openDialog = function (dialog, opener) {
    if (!dialog || dialog.open) return;
    dialog._skOpener = opener || document.activeElement;
    dialog._skScroll = window.scrollY;
    try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
    document.body.classList.add('sk-scroll-lock');
    openStack.push(dialog);
    requestAnimationFrame(function () { requestAnimationFrame(function () { dialog.classList.add('is-open'); }); });
    dialog.dispatchEvent(new CustomEvent('sk:open'));
  };
  SK.closeDialog = function (dialog) {
    if (!dialog || !dialog.open || dialog._skClosing) return;
    dialog._skClosing = true;
    dialog.classList.remove('is-open');
    var done = function () {
      dialog._skClosing = false;
      try { dialog.close(); } catch (e) { dialog.removeAttribute('open'); }
    };
    setTimeout(done, reduceMotion ? 0 : 380);
  };
  function onDialogClosed(dialog) {
    openStack = openStack.filter(function (d) { return d !== dialog; });
    if (!openStack.length) document.body.classList.remove('sk-scroll-lock');
    var o = dialog._skOpener;
    if (o && typeof o.focus === 'function' && document.contains(o)) { try { o.focus({ preventScroll: true }); } catch (e) {} }
    dialog.dispatchEvent(new CustomEvent('sk:closed'));
  }
  function initDialogs() {
    $$('dialog.sk-panel, dialog.sk-modal, dialog[data-sk-dialog]').forEach(function (d) {
      d.addEventListener('cancel', function (e) { e.preventDefault(); SK.closeDialog(d); });
      d.addEventListener('close', function () { d.classList.remove('is-open'); onDialogClosed(d); });
      d.addEventListener('click', function (e) {
        if (e.target === d) SK.closeDialog(d); // 背景（暗転部分）のクリック
        var c = e.target.closest('[data-sk-close]');
        if (c && d.contains(c)) SK.closeDialog(d);
      });
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sk-open]'); if (!b) return;
      var d = document.getElementById('sk-' + b.getAttribute('data-sk-open'));
      if (d) { e.preventDefault(); SK.openDialog(d, b); }
    });
  }

  /* メニューの階層 */
  function initMenu() {
    var menu = $('#sk-menu'); if (!menu) return;
    var levels = $$('[data-sk-level]', menu);
    function show(name) {
      levels.forEach(function (l) {
        var on = l.getAttribute('data-sk-level') === name;
        l.hidden = !on; l.classList.toggle('is-active', on);
        if (on) { l.classList.remove('is-entering'); void l.offsetWidth; l.classList.add('is-entering'); l.scrollTop = 0; }
      });
      $$('[data-sk-level-open]', menu).forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-sk-level-open') === name)); });
    }
    menu.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sk-level-open]'); if (o) { show(o.getAttribute('data-sk-level-open')); var back = $('[data-sk-level="' + o.getAttribute('data-sk-level-open') + '"] [data-sk-level-back]', menu); if (back) back.focus(); }
      if (e.target.closest('[data-sk-level-back]')) show('root');
    });
    menu.addEventListener('sk:closed', function () { show('root'); });
  }

  /* ---------- 5. 検索 ---------- */
  function initSearch() {
    var panel = $('#sk-search'); if (!panel) return;
    var input = $('[data-sk-search-input]', panel), live = $('[data-sk-search-list="live"]', panel);
    var empty = $('[data-sk-search-empty]', panel), tabs = $('[data-sk-search-tabs]', panel);
    var lists = $$('[data-sk-search-list]', panel), current = 'fragrance', timer = null, ctrl = null;
    function showList(name) {
      lists.forEach(function (l) { l.hidden = l.getAttribute('data-sk-search-list') !== name; });
      empty.hidden = true;
    }
    $$('[data-sk-search-tab]', panel).forEach(function (t) {
      t.addEventListener('click', function () {
        current = t.getAttribute('data-sk-search-tab');
        $$('[data-sk-search-tab]', panel).forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', String(on)); });
        if (!input.value.trim()) showList(current);
      });
    });
    panel.addEventListener('sk:open', function () { setTimeout(function () { input.focus(); }, 60); });
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function row(url, img, name, desc) {
      if (img && img.indexOf('cdn.shopify.com') > -1) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      return '<li><a class="sk-search__row" href="' + esc(url) + '"><span class="sk-search__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span><span class="sk-search__meta"><span class="sk-search__name">' + esc(name) + '</span><span class="sk-search__desc">' + esc(desc) + '</span></span></a></li>';
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (!q) { tabs.hidden = false; showList(current); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort(); ctrl = ('AbortController' in window) ? new AbortController() : null;
        var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (data) {
          var res = (data && data.resources && data.resources.results) || {}, html = '';
          (res.products || []).forEach(function (p) { if (/\/products\/the-years-before(?:[?#]|$)/.test(p.url)) return; /* 新サイトでは出さない（2026-10-23） */ var image = /\/products\/kimono(?:[?#]|$)/.test(p.url) ? panel.getAttribute('data-kimono-image') : (p.image || (p.featured_image && p.featured_image.url)); html += row(p.url, image, p.title, p.type || 'Fragrance'); });
          (res.articles || []).forEach(function (a) { html += row(a.url, a.image || (a.featured_image && a.featured_image.url), a.title, 'Journal'); });
          (res.pages || []).forEach(function (pg) { html += row(pg.url, '', pg.title, 'Page'); });
          tabs.hidden = true;
          live.innerHTML = html; showList('live'); empty.hidden = !!html;
        }).catch(function () {});
      }, 180);
    });
  }

  /* ---------- 6. 登録フォーム（Klaviyo）---------- */
  // 2026-10-05: 送信は本番テーマと同じ共通部品 window.siKlaviyoSubscribe(email, listId, source)（snippets/si-signup.liquid）。
  // Klaviyo 正規の窓口 Create Client Subscription（revision 2026-07-15）・流入元は profile.properties・登録元の名前は custom_source・
  // 返事が 202 以外は失敗＝下の catch でエラーを出し、ボタンを押し直せるように戻す。
  // ⬜旧＝manage.kmail-lists.com/ajax/subscriptions/subscribe（公式サポート外のため廃止。結果を見ていなかった）。
  function subscribeToList(listId, email, sourceLabel) {
    if (!window.siKlaviyoSubscribe) return Promise.reject(new Error('siKlaviyoSubscribe missing'));
    return window.siKlaviyoSubscribe(email, listId, sourceLabel);
  }
  function status(form, msg, kind) {
    var n = $('[data-sk-wl-status]', form); if (!n) return;
    n.textContent = msg; n.classList.toggle('is-error', kind === 'error'); n.classList.toggle('is-ok', kind === 'ok');
  }
  // 2026-10-26 Sho「gmail.comm などの打ち間違いに気づかせる表示」＝よくある打ち間違いの時だけ「Did you mean …?」を出す（送るのは止めない・1回だけ確認）。
  // 2通目の送信で届かなかった打ち間違い＝gnail.com／gmai.com／gmail.comm・.comb・.comc・.con／gmail.co。実在する形（hotmail.fr・yahoo.co.uk・mail.com など）には出さない。
  var EMAIL_KNOWN = ['gmail.com','googlemail.com','icloud.com','me.com','mac.com','hotmail.com','outlook.com','live.com','msn.com','yahoo.com','ymail.com','rocketmail.com','aol.com','mail.com','email.com','gmx.com','gmx.de','gmx.net','web.de','t-online.de','proton.me','protonmail.com','pm.me','tuta.com','tutanota.com','wp.pl','o2.pl','onet.pl','interia.pl','op.pl','free.fr','orange.fr','laposte.net','libero.it','zoho.com','fastmail.com','hey.com','qq.com','163.com','naver.com','yandex.ru','mail.ru'];
  var EMAIL_PROVIDERS = { gmail: 'com', googlemail: 'com', icloud: 'com', hotmail: '', outlook: '', yahoo: '', live: '', aol: '', protonmail: 'com' };
  var COM_TYPOS = ['con','comm','cmo','ocm','vom','xom','coom','cpm','cim','c0m','comb','comc','comn','coim','cpom','cop','vcom','xcom'];
  function editDistance(a, b) { // 入れ替え（hotmial）も1と数える
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++) {
      var c = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[a.length][b.length];
  }
  function suggestEmail(email) {
    var m = /^([^\s@]+)@([^\s@]+)$/.exec((email || '').trim().toLowerCase()); if (!m) return null;
    var local = m[1], domain = m[2].replace(/\.+$/, '');
    if (EMAIL_KNOWN.indexOf(domain) >= 0) return null;
    var dot = domain.indexOf('.'); var name = dot < 0 ? domain : domain.slice(0, dot), tld = dot < 0 ? '' : domain.slice(dot + 1);
    var fixedName = name;
    if (!EMAIL_PROVIDERS.hasOwnProperty(name) && name.length >= 4) {
      Object.keys(EMAIL_PROVIDERS).some(function (p) { if (p.length >= 5 && editDistance(name, p) === 1) { fixedName = p; return true; } return false; });
    }
    var fixedTld = tld;
    if (EMAIL_PROVIDERS.hasOwnProperty(fixedName) && EMAIL_PROVIDERS[fixedName]) fixedTld = EMAIL_PROVIDERS[fixedName];
    else if (!tld || COM_TYPOS.indexOf(tld) >= 0) fixedTld = 'com';
    var fixed = fixedName + '.' + fixedTld;
    if (fixed === domain) return null;
    if (fixedName === name && !EMAIL_PROVIDERS.hasOwnProperty(name) && COM_TYPOS.indexOf(tld) < 0) return null; // 知らない会社の名前で .com 以外は触らない
    return local + '@' + fixed;
  }
  SK.suggestEmail = suggestEmail;
  // メールの打ち間違いの確認（2026-11-02 Sho「警告が出ても、もう一度押すとそのまま送れてしまう」を直した版）。
  //  ・打ち間違いらしい時は「Did you mean …?」を出し、**直す（提案を押す）か「No, keep what I typed」を押すまで送れない**（送信をもう一度押しても通らない）。
  //  ・送信を押して止まった時は、案内の枠まで画面を動かして揺らし、赤い一行を出す（押しても反応しないように見えない）。
  //  ・対象＝ウェイトリスト／ニュースレター（全ページ・ポップアップ）と、問い合わせ・返品・撤回の3フォーム。⬜旧＝1回だけ止めて、2回目は通した版（2026-10-26〜11-02）。
  function initEmailSuggest(form, input) {
    var row = input.closest('.sk-wl__row') || input.parentNode;
    var box = document.createElement('div');
    box.className = 'sk-wl__suggest'; box.hidden = true; box.setAttribute('aria-live', 'polite');
    box.innerHTML = '<p class="sk-wl__suggest-q"><span>Did you mean </span><button type="button" class="sk-wl__suggest-fix"></button><span>?</span></p>' +
      '<button type="button" class="sk-wl__suggest-keep">No, keep what I typed</button>' +
      '<p class="sk-wl__suggest-note" hidden>Please check your email address before sending, so that we can reach you.</p>';
    row.appendChild(box);
    var fix = box.querySelector('.sk-wl__suggest-fix'), keep = box.querySelector('.sk-wl__suggest-keep'), note = box.querySelector('.sk-wl__suggest-note');
    var state = { suggestion: null, keptFor: null };
    function check() {
      var v = input.value.trim();
      if (state.keptFor !== null && state.keptFor !== v) state.keptFor = null;
      var sg = suggestEmail(v);
      state.suggestion = (sg && state.keptFor !== v) ? sg : null;
      if (state.suggestion) { fix.textContent = state.suggestion; box.hidden = false; }
      else { box.hidden = true; note.hidden = true; box.classList.remove('is-attention'); }
    }
    input.addEventListener('blur', check);
    input.addEventListener('input', function () { if (!box.hidden) check(); });
    fix.addEventListener('click', function () {
      input.value = state.suggestion || input.value; state.keptFor = null; check();
      input.dispatchEvent(new Event('input', { bubbles: true })); input.focus();
    });
    keep.addEventListener('click', function () {
      state.keptFor = input.value.trim(); check();
      input.dispatchEvent(new Event('input', { bubbles: true })); input.focus();
    });
    // 送る前に呼ぶ。提案が残っている間は false（＝送らない）。
    return function beforeSubmit() {
      check();
      if (!state.suggestion) return true;
      box.hidden = false; note.hidden = false;
      box.classList.remove('is-attention'); void box.offsetWidth; box.classList.add('is-attention'); // 揺らしをやり直す
      try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) { box.scrollIntoView(); }
      try { fix.focus({ preventScroll: true }); } catch (err) { fix.focus(); }
      return false;
    };
  }
  // 問い合わせ・返品のフォーム（Shopify 標準の通常送信）と撤回に、同じ確認を付ける。2026-11-02 W24。
  // 実例＝10/26 のお客さまが gmail.vim で送り返信できなかった／11/2 の撤回テストが icloud.comm のまま届いた。
  // Shopify の投稿よけ（hCaptcha）より先に動かすため、document の捕捉段階で受ける（止める時は後ろの処理にも渡さない）。
  // 通常送信の2つ（問い合わせ・返品）は、押してから投稿よけの確認が終わるまで 0.3〜5 秒、画面が何も変わらず見えるため、
  // 「Sending…」と一行の案内を出してボタンを止める（連打・押し直しで二重に送らない）。25 秒たっても進まなければ戻して知らせる。撤回は initWithdraw が同じことを自分で行う。
  function initFormEmailCheck() {
    ['sk-contact-form', 'return-form', 'withdraw-form'].forEach(function (id) {
      var form = document.getElementById(id); if (!form) return;
      var input = $('input[type="email"]', form); if (!input) return;
      var emailOk = initEmailSuggest(form, input);
      var btn = $('button[type="submit"]', form), label = btn ? btn.textContent : '', say = null, timer = null;
      if (id !== 'withdraw-form' && btn) {
        say = document.createElement('p'); say.className = 'sk-wl__status'; say.setAttribute('role', 'status'); say.setAttribute('aria-live', 'polite');
        btn.insertAdjacentElement('afterend', say);
      }
      function reset() { clearTimeout(timer); if (btn) { btn.disabled = false; btn.textContent = label; btn.removeAttribute('aria-busy'); } }
      document.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        if (!emailOk()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        if (!say) return;
        btn.disabled = true; btn.textContent = 'Sending…'; btn.setAttribute('aria-busy', 'true');
        say.textContent = 'Sending… this can take a few seconds. Please keep this page open.'; say.classList.remove('is-error');
        timer = setTimeout(function () {
          reset(); say.textContent = 'This is taking longer than expected. Please check your connection and press the button again.'; say.classList.add('is-error');
        }, 25000);
      }, true);
      window.addEventListener('pageshow', function (ev) { if (ev.persisted && say) { reset(); say.textContent = ''; } });
    });
  }
  function initWaitlistForms() {
    $$('[data-sk-waitlist]').forEach(function (form) {
      var input = $('input[type="email"]', form), btn = $('button[type="submit"]', form);
      var waitlist = $('input[name="waitlist_optin"]', form);
      var newsletter = $('input[name="newsletter_optin"]', form);
      if (!input || !btn) return;
      var busy = false;
      var emailOk = initEmailSuggest(form, input);
      function syncSubmitState() {
        var email = (input.value || '').trim();
        var validEmail = input.validity.valid && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        var hasChoice = !!((waitlist && waitlist.checked) || (newsletter && newsletter.checked));
        btn.disabled = busy || !validEmail || !hasChoice;
      }
      function updateSignup() {
        if (!busy && btn.textContent === 'Joined') btn.textContent = btn.getAttribute('data-label') || 'Join the list';
        syncSubmitState();
      }
      form.addEventListener('input', updateSignup);
      form.addEventListener('change', updateSignup);
      form.addEventListener('focusin', syncSubmitState);
      form.addEventListener('reset', function () { setTimeout(syncSubmitState, 0); });
      window.addEventListener('pageshow', syncSubmitState);
      syncSubmitState();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        syncSubmitState();
        if (btn.disabled) return;
        var email = (input.value || '').trim();
        var selected = { waitlist: !!(waitlist && waitlist.checked), newsletter: !!(newsletter && newsletter.checked) };
        var source = form.getAttribute('data-source') || 'Website';
        if (!email) { status(form, 'Email is required.', 'error'); input.focus(); return; }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { status(form, 'That doesn’t look like an email address.', 'error'); input.focus(); return; }
        if (!emailOk()) return;
        if (!selected.waitlist && !selected.newsletter) {
          status(form, 'Please choose Waitlist, Newsletter, or both.', 'error');
          if (waitlist) waitlist.focus();
          return;
        }
        var choices = [
          { selected: selected.waitlist, id: form.getAttribute('data-list-id') || 'Wmbkbf', name: 'Waitlist' },
          { selected: selected.newsletter, id: form.getAttribute('data-newsletter-id') || 'TpkBLU', name: 'Newsletter' }
        ].filter(function (choice) { return choice.selected; });
        // Retry a partial failure without re-subscribing this email to a successful list.
        if (!form._skSubscriptions || form._skSubscriptions.email !== email) form._skSubscriptions = { email: email, ids: [] };
        var completed = form._skSubscriptions.ids;
        var label = btn.getAttribute('data-label') || btn.textContent;
        busy = true; btn.textContent = 'Joining…'; syncSubmitState(); input.disabled = true;
        if (waitlist) waitlist.disabled = true;
        if (newsletter) newsletter.disabled = true;
        status(form, '', '');
        var chain = Promise.resolve();
        choices.forEach(function (choice) {
          if (completed.indexOf(choice.id) >= 0) return;
          chain = chain.then(function () {
            return subscribeToList(choice.id, email, source + ' (' + choice.name.toLowerCase() + ' opt-in)');
          }).then(function () { completed.push(choice.id); });
        });
        chain.then(function () {
          if (selected.waitlist) setCookie('shoito_v2_p5_done', '1', 365);
          var message = selected.waitlist && selected.newsletter ? 'You’re on the waitlist and subscribed to The Hidden Nose.' :
            selected.waitlist ? 'You’re on the waitlist.' : 'You’re subscribed to The Hidden Nose.';
          status(form, message, 'ok'); btn.textContent = 'Joined';
          input.value = ''; input.disabled = false;
          if (waitlist) waitlist.disabled = false;
          if (newsletter) newsletter.disabled = false;
          busy = false; syncSubmitState();
          var p1 = $('[data-sk-p1]');
          if (p1 && p1.open) SK.closeDialog(p1);
          setTimeout(function () { showP5(selected); }, 420);
        }).catch(function () {
          var saved = choices.filter(function (choice) { return completed.indexOf(choice.id) >= 0; });
          status(form, saved.length ? saved.map(function (choice) { return choice.name; }).join(' and ') +
            ' registration is saved. The remaining selection could not be added. Please try again.' :
            'Something went wrong. Please try again.', 'error');
          btn.textContent = label; input.disabled = false;
          if (waitlist) waitlist.disabled = false;
          if (newsletter) newsletter.disabled = false;
          busy = false; syncSubmitState();
        });
      });
    });
  }

  /* ---------- 7. P1 → ドック → P5 ---------- */
  var dock;
  function showDock() {
    // 登録済みの人にも出す（2026-10-21 Sho「気が向いた時にいつでも押せるように」）。⬜旧＝登録済みなら出さない
    if (!dock || document.querySelector('dialog[open]')) return;
    dock.hidden = false; requestAnimationFrame(function () { dock.classList.add('is-visible'); });
  }
  function hideDock() { if (!dock) return; dock.classList.remove('is-visible'); dock.hidden = true; }
  function showP5(selected) {
    selected = selected || { waitlist: true, newsletter: false };
    var p5 = $('[data-sk-p5]');
    hideDock();
    if (p5) {
      var label = $('[data-sk-signup-title]', p5);
      if (label) label.textContent = selected.waitlist ? 'You’re on the list' : 'You’re subscribed';
      $$('[data-sk-signup-note]', p5).forEach(function (note) { note.hidden = !selected[note.getAttribute('data-sk-signup-note')]; });
      SK.openDialog(p5);
    }
  }
  SK.showP5 = showP5;
  function initPopup() {
    var p1 = $('[data-sk-p1]'); dock = $('[data-sk-dock]');
    if (!p1) return;
    var cookie = p1.getAttribute('data-cookie') || 'shoito_v2_p1';
    var days = parseInt(p1.getAttribute('data-cookie-days'), 10) || 30;
    var delay = parseInt(p1.getAttribute('data-trigger-ms'), 10) || 3000;
    // 確認用: URL に ?sk_reset_popup=1 を付けると「閉じた／登録済み」の記録を消して最初から試せる（2026-10-05・本番サイトと同じ cookie 名のため、
    // 本番で登録・閉じたことがある端末では新テーマでもポップアップとドックが出ない＝それを確かめ直すため）
    if (/[?&]sk_reset_popup=1/.test(location.search)) { setCookie(cookie, '', -1); setCookie('shoito_v2_p5_done', '', -1); }
    var dismissed = !!getCookie(cookie);
    p1.addEventListener('sk:closed', function () { setCookie(cookie, 'shown', days); showDock(); });
    if (dock) dock.addEventListener('click', function () { hideDock(); SK.openDialog(p1, dock); });
    var p5 = $('[data-sk-p5]');
    if (p5) p5.addEventListener('sk:closed', showDock);
    // ドックは最初から出す（自動のポップアップが開く時だけ引っ込める）。登録済み・閉じた人には自動のポップアップは出さない
    showDock();
    if (!getCookie('shoito_v2_p5_done') && !dismissed) {
      var autoOpen = function () { hideDock(); SK.openDialog(p1); };
      setTimeout(function () { if (!document.querySelector('dialog[open]')) autoOpen(); else setTimeout(function retry() { if (!document.querySelector('dialog[open]')) autoOpen(); else setTimeout(retry, 1500); }, 1500); }, delay);
    }
    // サイト内の「Join the list」系リンク → ポップアップを開く（無ければ /pages/list へそのまま移動）
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sk-open-waitlist]'); if (!a) return;
      if (getCookie('shoito_v2_p5_done')) return; // 登録済みの人は従来どおり /pages/list へ
      e.preventDefault();
      var openD = document.querySelector('dialog[open]');
      if (openD && openD !== p1) { SK.closeDialog(openD); setTimeout(function () { hideDock(); SK.openDialog(p1, a); }, 400); }
      else { hideDock(); SK.openDialog(p1, a); }
    });
  }

  /* ---------- 8a. 動画（画面内で再生・外で停止・停止の意思を尊重） ---------- */
  SK.initVideo = function (root) {
    var v = root.querySelector('video'); if (!v) return;
    // PC 横版／スマホ縦版の出し分け（§24-3「mobile／desktop切替＝古い方を止めて対応版を表示」）
    if (v.hasAttribute('data-src-desktop')) {
      var mq = window.matchMedia('(max-width: 1023px)');
      var pick = function () {
        var src = mq.matches ? (v.getAttribute('data-src-mobile') || v.getAttribute('data-src-desktop')) : v.getAttribute('data-src-desktop');
        var poster = mq.matches ? (v.getAttribute('data-poster-mobile') || v.poster) : (v.getAttribute('data-poster-desktop') || v.poster);
        if (!v.getAttribute('data-poster-desktop')) v.setAttribute('data-poster-desktop', v.poster);
        if (v.getAttribute('src') !== src) { v.pause(); v.poster = poster; v.src = src; }
      };
      pick();
      if (mq.addEventListener) mq.addEventListener('change', function () { pick(); if (!root._skUserPaused) { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } });
    }
    var toggle = root.querySelector('[data-sk-video-toggle]'), mute = root.querySelector('[data-sk-video-mute]');
    root._skUserPaused = false; // Dior と同じく「動きを減らす」設定でも自動再生する（停止ボタンで止められる）。⬜旧＝その設定ならポスターのまま→端末によって写真に見えた（2026-10-05 Sho 指摘で変更）
    function setToggle() {
      if (!toggle) return;
      var paused = v.paused;
      toggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      toggle.innerHTML = paused ? toggle.getAttribute('data-icon-play') : toggle.getAttribute('data-icon-pause');
    }
    function tryPlay() { if (root._skUserPaused || root._skHeld) return; var p = v.play(); if (p && p.catch) p.catch(function () { setToggle(); }); }
    v.addEventListener('play', setToggle); v.addEventListener('pause', setToggle);
    if (toggle) toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (v.paused) { root._skUserPaused = false; root._skHeld = false; tryPlay(); } else { root._skUserPaused = true; v.pause(); }
    });
    if (mute) mute.addEventListener('click', function (e) {
      e.stopPropagation();
      v.muted = !v.muted;
      mute.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute');
      mute.innerHTML = v.muted ? mute.getAttribute('data-icon-muted') : mute.getAttribute('data-icon-sound');
      if (!v.muted && v.paused) { root._skUserPaused = false; tryPlay(); }
    });
    // Hero clip-path changes must not trigger a visibility pause; manual pause still wins.
    var continuous = root.hasAttribute('data-sk-video-continuous'), inView = continuous;
    // 読み込みが終わる前の play() は空振りすることがある → 再生できる状態になった時にもう一度
    v.addEventListener('canplay', function () { if (inView) tryPlay(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden && inView) tryPlay(); });
    if (!continuous && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { inView = en.isIntersecting; if (inView) tryPlay(); else v.pause(); });
      }, { threshold: 0.25 }).observe(root);
    } else { inView = true; tryPlay(); }
    root.skHold = function (h) { root._skHeld = h; if (h) v.pause(); else tryPlay(); };
    setToggle();
  };

  /* ---------- 8b. 位置表示つきカルーセル（停止位置の数 ≠ 画像の枚数＝§07-2） ---------- */
  SK.initCarousel = function (root) {
    var track = root.querySelector('[data-sk-track]'); if (!track) return;
    var prev = root.querySelector('[data-sk-prev]'), next = root.querySelector('[data-sk-next]'), out = root.querySelector('[data-sk-pos]');
    // data-sk-step="page" … 見えている枚数ぶんずつ送る（サービス区画＝§08-3 の PC 1/2・スマホ 1/4 に合わせる）
    function step() {
      var c = track.children; if (c.length < 2) return track.clientWidth;
      var one = c[1].offsetLeft - c[0].offsetLeft;
      if (root.getAttribute('data-sk-step') === 'page') return Math.max(1, Math.floor((track.clientWidth + 1) / one)) * one;
      return one;
    }
    function total() { var max = track.scrollWidth - track.clientWidth; return max <= 2 ? 1 : Math.ceil((max - 2) / step()) + 1; }
    function index() { var max = track.scrollWidth - track.clientWidth; if (track.scrollLeft >= max - 2) return total(); return Math.round(track.scrollLeft / step()) + 1; }
    function update() {
      var i = index(), n = total();
      if (out) out.textContent = i + '/' + n;
      if (prev) prev.disabled = i <= 1;
      if (next) next.disabled = i >= n;
      root.classList.toggle('is-static', n <= 1);
    }
    function go(d) {
      var i = index() - 1 + d, max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: Math.max(0, Math.min(max, i * step())), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  /* ---------- 8c. スクロールで現れる ---------- */
  function initReveal() {
    var els = $$('.sk-reveal'); if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 9. Cookie 設定・コントラスト・カート件数 ---------- */
  // Cookie の設定を開き直す（2026-10-19 W26 見直し）。
  // Shopify の同意画面（privacyBanner）は同意が必要な地域（EU・英国など）でだけ動く。米国など同意画面の無い地域や、
  // 画面が開かなかった時は、何も起きないままにせずリンク先（Legal の Cookies の説明）へそのまま移動する。
  function initCookiePrefs() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sk-cookie-prefs]'); if (!a) return;
      var pb = window.privacyBanner;
      if (!pb || typeof pb.showPreferences !== 'function') return; // 通常のリンクとして移動
      e.preventDefault();
      var href = a.getAttribute('href');
      try { pb.showPreferences(); } catch (err) { location.href = href; return; }
      setTimeout(function () {
        var d = document.getElementById('shopify-pc__prefs__dialog');
        if (!d || !d.offsetHeight) location.href = href;
      }, 900);
    });
  }
  // フォームの小さな補助（2026-10-19 W24）:
  //  ・?order=1024 / ?email=… 付きで開いた時、data-sk-prefill-key の欄に入れる（注文確認メールからの返品・問い合わせ用）
  //  ・送信後の「受け付けました」やエラーの枠（data-sk-focus-on-load）へ画面とフォーカスを移す
  function initFormHelpers() {
    var q; try { q = new URLSearchParams(location.search); } catch (err) { return; }
    $$('[data-sk-prefill-key]').forEach(function (el) {
      var v = q.get(el.getAttribute('data-sk-prefill-key'));
      if (v && !el.value) el.value = v.slice(0, 120);
    });
    var t = $('[data-sk-focus-on-load]');
    if (t) setTimeout(function () { t.scrollIntoView({ block: 'center' }); try { t.focus({ preventScroll: true }); } catch (err) { t.focus(); } }, 150); // URL の # への移動が終わってから
  }
  function initContrast() {
    var sw = $('[data-sk-contrast]');
    if (store('sk_contrast') === '1') { document.documentElement.classList.add('sk-contrast'); if (sw) sw.checked = true; }
    if (sw) sw.addEventListener('change', function () { document.documentElement.classList.toggle('sk-contrast', sw.checked); store('sk_contrast', sw.checked ? '1' : '0'); });
  }
  SK.refreshCartCount = function () {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-sk-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.hidden = !c.item_count; }); return c; });
  };

  // 撤回ボタン（EU 指令 2011/83 第11a条・2026-10-19）＝返品ページの #withdraw。仕様の説明は sections/sk-page.liquid の同じ所。
  //  ①Klaviyo に出来事「Withdrawal Requested」を送る（受付メールは Klaviyo の自動送信が送る）
  //  ②同じ内容を Shopify の問い合わせ（info@ 宛）としてページを読み直さずに送る
  //  ③画面に内容と送った日時を出す。Shopify に確認を求められた時（ボット対策）だけ通常の送信に切り替える。
  function initWithdraw() {
    var form = document.getElementById('withdraw-form'); if (!form) return;
    var $f = function (q) { return form.querySelector(q); };
    var err = $f('[data-sk-withdraw-error]'), btn = $f('[data-sk-withdraw-submit]');
    var FLAG = 'sk_withdraw_last';
    var busy = false, sendTimer = null, say = null;
    function fmt(d) {
      var M = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      function p2(n) { return (n < 10 ? '0' : '') + n; }
      return d.getUTCDate() + ' ' + M[d.getUTCMonth()] + ' ' + d.getUTCFullYear() + ', ' + p2(d.getUTCHours()) + ':' + p2(d.getUTCMinutes()) + ':' + p2(d.getUTCSeconds()) + ' UTC';
    }
    function showDone(rec) {
      $f('[data-sk-withdraw-fields]').hidden = true; err.hidden = true;
      var dl = $f('[data-sk-withdraw-summary]'); dl.textContent = '';
      [['Name', rec.name], ['Order number', rec.order], ['Email', rec.email], ['Sent on', rec.when], ['Your statement', rec.statement]].forEach(function (r) {
        var dt = document.createElement('dt'); dt.textContent = r[0]; var dd = document.createElement('dd'); dd.textContent = r[1]; dl.appendChild(dt); dl.appendChild(dd);
      });
      $f('[data-sk-withdraw-next]').textContent = rec.ack
        ? 'An acknowledgement with these details is on its way to ' + rec.email + '. If it does not arrive, please check your spam folder.'
        : 'Your withdrawal has reached us. Our team will email the acknowledgement to ' + rec.email + ' shortly.';
      var done = $f('[data-sk-withdraw-done]'); done.hidden = false;
      setTimeout(function () { done.scrollIntoView({ block: 'center' }); try { done.focus({ preventScroll: true }); } catch (e) { done.focus(); } }, 150);
    }
    function fail(msg) { clearTimeout(sendTimer); busy = false; form.removeAttribute('data-sk-native'); if (say) say.textContent = ''; err.textContent = msg; err.hidden = false; btn.disabled = false; btn.textContent = 'Confirm withdrawal'; try { err.focus(); } catch (e) {} }
    // 通常の送信（ボット対策の確認を経由）から戻ってきた時: 撤回の受付を出し、返品フォームの「受け付けました」は撤回のものなので元に戻す
    try {
      var last = JSON.parse(sessionStorage.getItem(FLAG) || 'null');
      if (last && /[?&]contact_posted=true/.test(location.search) && Date.now() - last.ts < 30 * 60 * 1000) {
        sessionStorage.removeItem(FLAG);
        var rd = document.querySelector('[data-sk-return-done]'), rf = document.querySelector('[data-sk-return-fields]');
        if (rd && rf) { rd.hidden = true; rf.hidden = false; rd.removeAttribute('data-sk-focus-on-load'); }
        showDone(last);
      }
    } catch (e) {}
    // 🔴 送り方は1本だけ（2026-11-02 原因を再現して確認）。⬜旧＝①Klaviyo の返事を待つ→②隠し欄を埋める→③ fetch で Shopify に送る、と並べていたが、
    //    Shopify の投稿よけ（hCaptcha）は押した約 0.3 秒後に **その時の入力のまま**通常送信する。Klaviyo の返事（約 0.5〜1 秒）より早く、隠し欄（文面・日時・受付の案内）が空のまま
    //    info@ に届いていた（Body／Submitted At／Acknowledgement Email が空）。
    //    今＝①最初の押下は document の捕捉段階で止める（投稿よけにも渡さない）→②Klaviyo の返事を待って隠し欄を埋める→③ data-sk-native を付けて requestSubmit＝投稿よけ経由の通常送信に1回だけ任せる。
    say = document.createElement('p'); say.className = 'sk-wl__status'; say.setAttribute('role', 'status'); say.setAttribute('aria-live', 'polite');
    btn.insertAdjacentElement('afterend', say);
    window.addEventListener('pageshow', function (ev) { if (ev.persisted && busy) { fail('Your withdrawal was not sent. Please press the button again, or write to info@shoitotokyo.com with your name and order number.'); } });
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (form.getAttribute('data-sk-native') === '1') return; // ③の送信＝投稿よけに任せる
      e.preventDefault(); e.stopImmediatePropagation(); if (busy) return;
      busy = true; btn.disabled = true; btn.textContent = 'Sending…'; err.hidden = true;
      say.textContent = 'Sending your withdrawal… this can take a few seconds. Please keep this page open.';
      var name = $f('[name="contact[name]"]').value.trim(), order = $f('[name="contact[Order number]"]').value.trim(), email = $f('[name="contact[email]"]').value.trim();
      var now = new Date(), when = fmt(now), iso = now.toISOString();
      var statement = 'I hereby give notice that I withdraw from my contract of sale for order ' + order + '.';
      var rec = { name: name, order: order, email: email, when: when, iso: iso, statement: statement, ack: false, ts: Date.now() };
      // ① Klaviyo（受付メールのきっかけ）。12 秒で打ち切る
      var kl = (function () {
        var body = { data: { type: 'event', attributes: {
          properties: { name: name, order_number: order, email: email, submitted_at: iso, submitted_at_text: when, statement: statement, page: location.pathname },
          time: iso, unique_id: 'withdraw-' + order.replace(/[^\w-]/g, '') + '-' + now.getTime(),
          metric: { data: { type: 'metric', attributes: { name: 'Withdrawal Requested' } } },
          profile: { data: { type: 'profile', attributes: { email: email, first_name: name } } } } } };
        var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null, t = ctrl && setTimeout(function () { ctrl.abort(); }, 12000);
        return fetch('https://a.klaviyo.com/client/events/?company_id=Ry3KwE', { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' }, body: JSON.stringify(body), signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { if (t) clearTimeout(t); return r.status === 202; }, function () { if (t) clearTimeout(t); return false; });
      })();
      kl.then(function (ok) {
        rec.ack = ok;
        // ② 隠し欄を埋める（送る直前に）。Klaviyo が受け付けても、メール配信を止めた人には受付メールが送られない（transactional の審査が通るまで）＝info@ の担当が確かめられる書き方にする
        $f('[data-sk-withdraw-body]').value = statement + '\nSubmitted at: ' + when + ' (' + iso + ')\nWithdraw form on ' + location.hostname + location.pathname;
        $f('[data-sk-withdraw-time]').value = when;
        $f('[data-sk-withdraw-ack]').value = ok ? 'Klaviyo received the event "Withdrawal Requested" (flow Ydj9MT sends the acknowledgement). CHECK in Klaviyo that it was sent: if this customer has unsubscribed from email, it is NOT sent until the flow is approved as transactional — then email the acknowledgement by hand (content and date/time above).' : 'NOT sent automatically — please email the acknowledgement by hand today (content and date/time above).';
        try { sessionStorage.setItem(FLAG, JSON.stringify(rec)); } catch (err2) {}
        // ③ 通常送信（投稿よけの確認つき）。戻ってきた時は上の FLAG で「受け付けました」を出す。30 秒たっても進まなければ戻して知らせる
        sendTimer = setTimeout(function () { try { sessionStorage.removeItem(FLAG); } catch (err3) {} fail('Your withdrawal could not be sent. Please check your connection and try again, or write to info@shoitotokyo.com with your name and order number.'); }, 30000);
        form.setAttribute('data-sk-native', '1');
        form.requestSubmit();
      });
    }, true);
  }

  // 届けられない国から来た人だけに出す小さな知らせ（2026-10-24）。説明は layout/theme.liquid の同じ部品の所。
  function initShipNote() {
    var box = document.querySelector('[data-sk-shipnote]'); if (!box) return;
    var KEY = 'sk_shipnote_closed';
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    var allowed = (box.getAttribute('data-allowed') || '').split(',');
    var test = null; try { test = new URLSearchParams(location.search).get('sk_test_country'); } catch (e) {}
    function show(code, name) {
      if (!code || allowed.indexOf(code.toUpperCase()) !== -1) return;
      var c = box.querySelector('[data-sk-shipnote-country]'); if (c && name) c.textContent = name;
      // Cookie の同意画面が出ている間は待つ（下の端で重ならないように）。最大 60 秒
      var tries = 0;
      (function wait() {
        var b = document.getElementById('shopify-pc__banner');
        var busy = b && b.offsetHeight > 0 && getComputedStyle(b).display !== 'none';
        if (busy && tries++ < 60) { setTimeout(wait, 1000); return; }
        // スマホは下の端に購入ボタンの帯と登録ボタンが出るので、浮かせずにページのいちばん上に細い帯として置く
        if (window.matchMedia('(max-width: 767px)').matches) { box.classList.add('sk-shipnote--top'); document.body.insertBefore(box, document.body.firstChild); }
        box.hidden = false; requestAnimationFrame(function () { box.classList.add('is-in'); });
      })();
    }
    box.querySelector('[data-sk-shipnote-close]').addEventListener('click', function () {
      box.classList.remove('is-in'); box.hidden = true; try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    });
    if (test) { show(test, test.toUpperCase() === 'JP' ? 'Japan' : test.toUpperCase()); return; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { var c = d && d.detected_values && d.detected_values.country; if (c) show(c.handle, c.name); })
      .catch(function () {});
  }

  function init() {
    initAnnouncement(); initHeader(); initDialogs(); initMenu(); initSearch();
    initWaitlistForms(); initPopup(); initReveal(); initCookiePrefs(); initFormHelpers(); initFormEmailCheck(); initWithdraw(); initShipNote(); initContrast();
    $$('[data-sk-video]').forEach(SK.initVideo);
    $$('[data-sk-carousel]').forEach(SK.initCarousel);
    document.dispatchEvent(new CustomEvent('sk:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
